/* ============================================================
   NattyPLUS Birthday Sale Cart Drawer (np-birthday-cart-drawer.js)
   ============================================================
   Vanilla JS runtime for sections/np-birthday-cart-drawer.liquid.
   Implements the same np-cart-sync contract as np-cart-drawer.js.
   ============================================================ */

(function () {
  'use strict';
  if (window.__npBirthdayCartDrawerV) return;
  window.__npBirthdayCartDrawerV = 1;

  var DRAWER_ID = 'CartDrawer';
  var DRAWER_TAG = 'np-birthday-cart-drawer';
  var ITEM_TAG = 'np-birthday-cart-item';
  var QTY_INPUT_SEL = '[data-quantity-input]';
  var SCROLL_LOCK_CLASS = 'np-cart-scroll-lock';
  var FALLBACK_DEBOUNCE = 450;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function ensureScrollLockStyle() {
    if (document.getElementById('np-birthday-cart-scroll-lock')) return;
    var s = document.createElement('style');
    s.id = 'np-birthday-cart-scroll-lock';
    s.textContent =
      'html.' + SCROLL_LOCK_CLASS + ', body.' + SCROLL_LOCK_CLASS +
      '{overflow:hidden !important;touch-action:none;}';
    document.head.appendChild(s);
  }

  function parseMoneyEl(el) {
    if (!el) return 0;
    var t = (el.textContent || '').replace(/[^\d.,]/g, '').replace(',', '');
    var n = parseFloat(t);
    return isNaN(n) ? 0 : n;
  }

  function defineCartItem() {
    if (customElements.get(ITEM_TAG)) return;
    customElements.define(ITEM_TAG, class extends HTMLElement {
      setLoading(isLoading) { this.toggleAttribute('is-loading', !!isLoading); }
      setDisabled(isDisabled) {
        $all('[data-np-qty-dec],[data-np-qty-inc],[data-np-remove]', this).forEach(function (b) {
          b.disabled = !!isDisabled;
        });
        var input = this.querySelector(QTY_INPUT_SEL);
        if (input) input.disabled = !!isDisabled || !!this.closest('[data-np-free-gift]');
      }
      removeItem() {
        var self = this;
        return new Promise(function (resolve) {
          var h = self.offsetHeight;
          self.style.maxHeight = h + 'px';
          void self.offsetHeight;
          requestAnimationFrame(function () {
            self.style.maxHeight = '0px';
            self.style.opacity = '0';
            self.style.marginBottom = '0';
            self.style.paddingTop = '0';
            self.style.paddingBottom = '0';
          });
          var done = false;
          function finish() { if (done) return; done = true; resolve(); }
          self.addEventListener('transitionend', finish, { once: true });
          setTimeout(finish, 350);
        });
      }
    });
  }

  function defineCartDrawer() {
    if (customElements.get(DRAWER_TAG)) return;

    customElements.define(DRAWER_TAG, class extends HTMLElement {
      connectedCallback() {
        if (this.__wired) return;
        this.__wired = true;
        this.isDrawer = true;
        this._open = false;
        this.overlay = null;
        ensureScrollLockStyle();
        this.ensureOverlay();
        this.bindShellEvents();
        this.bindItemEvents();
        this.wireItems();
        this.__mounted = false;
        var self = this;
        var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };
        idle(function () { if (!self.__mounted) self.mount(); });
      }

      ensureMounted() { if (!this.__mounted) this.mount(); }

      getTemplateContent(doc) {
        var tmpl = (doc || document).querySelector('[data-sidebar-template="' + this.id + '"]')
          || (doc || this).querySelector('template[data-sidebar-template]');
        if (tmpl && tmpl.content) {
          var frag = tmpl.content.cloneNode(true);
          return frag.firstElementChild || frag;
        }
        var body = (doc || this).querySelector('[data-sidebar-body]');
        return body ? body.cloneNode(true) : null;
      }

      mount(node) {
        var canonical = node || this.element || this.getTemplateContent(this);
        if (!canonical) return;
        this.element = canonical;
        this.replaceChildren(this.element.cloneNode(true));
        this.__mounted = true;
        this.readConfig();
        this.startTimer();
        this.updateShipping();
        this.updateUpsellState();
        this.bindBodyEvents();
      }

      // Read the visible qty (falls back to data-quantity / hidden input).
      readItemQty(item) {
        if (!item) return 1;
        var display = item.querySelector('[data-np-qty-display]');
        var input = item.querySelector(QTY_INPUT_SEL);
        var val = display ? parseInt(display.textContent, 10) : NaN;
        if (isNaN(val)) val = parseInt(item.dataset.quantity, 10);
        if (isNaN(val) && input) val = parseInt(input.value, 10);
        if (isNaN(val) || val < 1) val = 1;
        return val;
      }

      setItemQty(item, qty) {
        if (!item) return;
        qty = Math.max(0, qty);
        var input = item.querySelector(QTY_INPUT_SEL);
        var display = item.querySelector('[data-np-qty-display]');
        if (input) input.value = String(qty || 1);
        if (display) display.textContent = String(qty || 1);
      }

      readConfig() {
        var cfg = this.querySelector('[data-np-bday-config]');
        var fixedShip = cfg ? parseFloat(cfg.getAttribute('data-free-ship') || '0') : 0;
        var baseUsd = cfg ? parseFloat(cfg.getAttribute('data-free-ship-base-usd') || '0') : 0;
        var shipDollars = fixedShip;
        if (!shipDollars && baseUsd > 0) {
          var r = 1;
          try { if (window.Shopify && Shopify.currency && Shopify.currency.rate) r = parseFloat(Shopify.currency.rate) || 1; } catch (e) {}
          shipDollars = Math.round(baseUsd * r);
        }
        if (!shipDollars) shipDollars = 200;
        this.__cfg = {
          freeShip: shipDollars * 100,
          timerEnd: cfg ? cfg.getAttribute('data-timer-end') : '',
          showTimer: cfg ? cfg.getAttribute('data-show-timer') !== 'false' : true,
          moneyFormat: cfg ? cfg.getAttribute('data-money-format') : '${{amount}}'
        };
      }

      get isOpen() { return this._open; }

      ensureOverlay() {
        if (this.overlay && document.body.contains(this.overlay)) return;
        var ov = document.createElement('div');
        ov.className = 'np-birthday-cart-overlay';
        ov.setAttribute('data-np-bday-overlay', '');
        document.body.appendChild(ov);
        this.overlay = ov;
        ov.addEventListener('click', this.close.bind(this));
      }

      open() {
        this.ensureMounted();
        this.ensureOverlay();
        this._open = true;
        this.setAttribute('is-opened', '');
        this.overlay.classList.add('is-visible');
        document.documentElement.classList.add(SCROLL_LOCK_CLASS);
        document.body.classList.add(SCROLL_LOCK_CLASS);
        $all('[data-sidebar-button][data-sidebar-id="' + this.id + '"]').forEach(function (b) {
          b.classList.add('is-opened');
        });
        this.updateShipping();
        return Promise.resolve();
      }

      close() {
        this._open = false;
        this.removeAttribute('is-opened');
        if (this.overlay) this.overlay.classList.remove('is-visible');
        document.documentElement.classList.remove(SCROLL_LOCK_CLASS);
        document.body.classList.remove(SCROLL_LOCK_CLASS);
        $all('[data-sidebar-button][data-sidebar-id="' + this.id + '"]').forEach(function (b) {
          b.classList.remove('is-opened');
        });
        return Promise.resolve();
      }

      toggle() { return this._open ? this.close() : this.open(); }

      bindShellEvents() {
        var self = this;
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && self._open) self.close();
        });
        if (!this.__shellClick) {
          this.__shellClick = true;
          document.addEventListener('click', function (e) {
            var btn = e.target.closest && e.target.closest('[data-sidebar-button][data-sidebar-id="' + DRAWER_ID + '"], [data-np-cart-open]');
            if (!btn) return;
            var drawer = document.getElementById(DRAWER_ID) || document.querySelector(DRAWER_TAG);
            if (!drawer || typeof drawer.toggle !== 'function') return;
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            drawer.toggle();
          }, true);
        }
      }

      bindBodyEvents() {
        var self = this;
        var closeBtn = this.querySelector('[data-np-bday-close]');
        if (closeBtn && !closeBtn.__wired) {
          closeBtn.__wired = true;
          closeBtn.addEventListener('click', function (e) { e.preventDefault(); self.close(); });
        }
        var checkout = this.querySelector('[data-np-bday-checkout]');
        if (checkout && !checkout.__wired) {
          checkout.__wired = true;
          checkout.addEventListener('click', function (e) {
            if (checkout.disabled) { e.preventDefault(); return; }
            checkout.classList.add('is-loading');
          });
        }
      }

      bindItemEvents() {
        var self = this;
        // Bound once on the custom element — mount() replaces body children but
        // must NOT re-add this listener (was causing +N jumps per click).
        if (this.__itemClickWired) return;
        this.__itemClickWired = true;

        this.addEventListener('click', function (e) {
          var t = e.target;
          var dec = t.closest && t.closest('[data-np-qty-dec]');
          var inc = t.closest && t.closest('[data-np-qty-inc]');
          var rem = t.closest && t.closest('[data-np-remove]');
          var add = t.closest && t.closest('[data-np-upsell-add]');

          if (dec || inc) {
            e.preventDefault();
            var item = (dec || inc).closest(ITEM_TAG);
            if (!item || item.hasAttribute('data-np-free-gift')) return;
            var input = item.querySelector(QTY_INPUT_SEL);
            if (!input) return;
            var val = self.readItemQty(item);
            if (dec) {
              if (val <= 1) {
                var idx = parseInt(item.dataset.index, 10);
                if (!isNaN(idx) && typeof self.updateItem === 'function') self.updateItem(idx, 0);
                return;
              }
              val -= 1;
            } else {
              val += 1;
            }
            self.setItemQty(item, val);
            input.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }

          if (rem) {
            e.preventDefault();
            var row = rem.closest(ITEM_TAG);
            var index = row && parseInt(row.dataset.index, 10);
            if (!isNaN(index) && typeof self.updateItem === 'function') self.updateItem(index, 0);
            return;
          }

          if (add && !add.disabled) {
            e.preventDefault();
            self.upsellAdd(add.closest('[data-np-upsell]'), add);
          }
        });
      }

      wireItems() {
        var self = this;
        if (this.__changeWired) return;
        this.__changeWired = true;

        var timers = {};
        this.addEventListener('change', function (e) {
          var input = e.target;
          if (!input || !input.matches || !input.matches(QTY_INPUT_SEL)) return;
          if (input.closest('[data-np-free-gift]')) return;
          if (!self.__npFallbackUpdate) return;
          var index = parseInt(input.dataset.index, 10);
          if (isNaN(index)) return;
          var qty = parseInt(input.value, 10) || 0;
          var display = input.closest(ITEM_TAG) && input.closest(ITEM_TAG).querySelector('[data-np-qty-display]');
          if (display) display.textContent = String(Math.max(qty, 0));
          clearTimeout(timers[index]);
          timers[index] = setTimeout(function () { self.updateItem(index, qty); }, FALLBACK_DEBOUNCE);
        });
      }

      upsellAdd(row, btn) {
        if (!row || row.__adding || row.classList.contains('added') || btn.disabled) return;
        var variantId = parseInt(row.getAttribute('data-variant-id'), 10);
        if (!variantId) return;
        row.__adding = true;
        btn.disabled = true;
        btn.classList.add('is-loading');
        var original = btn.textContent;
        btn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        }).then(function (res) {
          if (!res.ok) return res.json().catch(function () { return {}; }).then(function (err) {
            throw new Error(err.description || err.message || 'Add failed');
          });
          return res.json();
        }).then(function () {
          if (window.NPCartSync && typeof window.NPCartSync.refresh === 'function') {
            return window.NPCartSync.refresh({ open: true });
          }
        }).then(function () {
          btn.textContent = 'Added ✓';
          setTimeout(function () { btn.textContent = original; }, 1200);
        }).catch(function (e) {
          console.warn('[np-birthday-cart]', e && e.message ? e.message : e);
          btn.textContent = 'Try again';
          btn.disabled = false;
          row.__adding = false;
          btn.classList.remove('is-loading');
        });
      }

      updateUpsellState() {
        var handles = [];
        $all(ITEM_TAG, this).forEach(function (item) {
          if (item.dataset.productHandle) handles.push(item.dataset.productHandle);
        });
        $all('[data-np-upsell]', this).forEach(function (row) {
          var h = row.getAttribute('data-product-handle');
          var inCart = h && handles.indexOf(h) !== -1;
          row.classList.toggle('added', inCart);
          var btn = row.querySelector('[data-np-upsell-add]');
          if (!btn) return;
          var label = btn.getAttribute('data-np-upsell-label') || '+ Add';
          btn.disabled = inCart;
          btn.setAttribute('aria-disabled', inCart ? 'true' : 'false');
          if (inCart) {
            btn.textContent = 'Added';
            btn.classList.remove('is-loading');
          } else if (!row.__adding) {
            btn.textContent = label;
          }
        });
      }

      updateShipping() {
        var cfg = this.__cfg || {};
        var threshold = cfg.freeShip || 20000;
        var totalEl = this.querySelector('[data-np-cart-total-cents]');
        var total = totalEl ? parseInt(totalEl.getAttribute('data-np-cart-total-cents') || '0', 10) : 0;
        var ship = this.querySelector('[data-np-ship]');
        var line = this.querySelector('[data-np-ship-line]');
        var bar = this.querySelector('[data-np-ship-bar]');
        if (!ship || !line || !bar) return;
        var pct = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 0;
        bar.style.width = pct + '%';
        if (total >= threshold) {
          ship.classList.add('done');
          line.innerHTML = '&#10003; <b>FREE SHIPPING</b> unlocked';
        } else {
          ship.classList.remove('done');
          var remain = (threshold - total) / 100;
          line.innerHTML = 'You&rsquo;re <b>' + this.formatMoney(remain) + '</b> from <b>FREE SHIPPING</b>';
        }
      }

      formatMoney(dollars) {
        var cfg = this.__cfg || {};
        var fmt = cfg.moneyFormat || '${{amount}}';
        var amount = (Math.round(dollars * 100) / 100).toFixed(2);
        // Shopify's default money_format placeholders:
        // - {{amount}} (decimal with dot)
        // - {{amount_no_decimals}}
        // Some locales/currencies use {{amount_with_comma_separator}}.
        // We must support it because otherwise it leaks as a raw template string.
        var amountComma = amount.replace('.', ',');
        return fmt
          .replace(/\{\{\s*amount\s*\}\}/, amount)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(dollars).toString())
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amountComma);
      }

      startTimer() {
        var self = this;
        var cfg = this.__cfg || {};
        var saleBar = this.querySelector('[data-np-bday-sale]');
        if (!saleBar || cfg.showTimer === false) {
          if (saleBar) saleBar.setAttribute('hidden', '');
          return;
        }
        var endMs = Date.parse(cfg.timerEnd || '');
        if (isNaN(endMs)) {
          saleBar.setAttribute('hidden', '');
          return;
        }
        var clock = saleBar.querySelector('[data-np-bday-clock]');
        if (!clock) return;

        function pad(n) { return (n < 10 ? '0' : '') + n; }
        function tick() {
          var diff = endMs - Date.now();
          if (diff <= 0) {
            saleBar.setAttribute('hidden', '');
            clearInterval(self.__timerId);
            return;
          }
          var s = Math.floor(diff / 1000);
          var d = clock.querySelector('[data-d]');
          var h = clock.querySelector('[data-h]');
          var m = clock.querySelector('[data-m]');
          var sec = clock.querySelector('[data-s]');
          if (d) d.textContent = pad(Math.floor(s / 86400));
          if (h) h.textContent = pad(Math.floor((s % 86400) / 3600));
          if (m) m.textContent = pad(Math.floor((s % 3600) / 60));
          if (sec) sec.textContent = pad(s % 60);
        }
        saleBar.removeAttribute('hidden');
        tick();
        clearInterval(this.__timerId);
        this.__timerId = setInterval(tick, 1000);
      }

      setLoadingStatus(isLoading) { this.classList.toggle('is-cart-loading', !!isLoading); }
      setPreEmpty(isEmpty) { this.classList.toggle('is-pre-empty', !!isEmpty); }
      updateEmptyStatus(isEmpty) {
        var empty = (typeof isEmpty === 'boolean') ? isEmpty : this.querySelectorAll(ITEM_TAG).length === 0;
        this.toggleAttribute('is-empty', empty);
        this.toggleAttribute('empty-cart', empty);
      }
      setCartState() { this.updateEmptyStatus(); }

      emit(name, detail) {
        if (name === 'update-nodes' && detail && detail.node) this.applyUpdateNodes(detail.node);
        try { this.dispatchEvent(new CustomEvent(name, { detail: detail || {}, bubbles: true })); } catch (e) {}
      }

      applyUpdateNodes(node) {
        var freshBody = null;
        if (node.nodeType === 9 || node.querySelector) {
          freshBody = node.querySelector ? (node.querySelector('[data-sidebar-body]') || null) : null;
        }
        if (!freshBody && node.matches && node.matches('[data-sidebar-body]')) freshBody = node;
        if (freshBody) {
          this.element = freshBody.cloneNode(true);
          this.replaceChildren(this.element.cloneNode(true));
          this.__mounted = true;
          this.readConfig();
          this.startTimer();
          this.updateShipping();
          this.updateUpsellState();
          this.bindBodyEvents();
        }
      }

      purchaseHandler(doc, parsedState) {
        this.setPreEmpty(false);
        var body = this.getTemplateContent(doc);
        if (body) this.mount(body);
        var fresh = (doc && doc.querySelector) ? (doc.querySelector(DRAWER_TAG) || doc.querySelector('#' + this.id)) : null;
        if (fresh) {
          this.toggleAttribute('is-empty', fresh.hasAttribute('is-empty'));
          this.toggleAttribute('empty-cart', fresh.hasAttribute('empty-cart'));
        } else {
          this.updateEmptyStatus();
        }
        this.updateHeaderCountFromDoc(doc);
        return this.open();
      }

      updateHeaderCountFromDoc(doc) {
        if (!doc || !doc.querySelector) return;
        var newCount = doc.querySelector('#NewCartCount');
        if (!newCount) return;
        $all('#CartCount').forEach(function (el) {
          el.replaceChildren.apply(el, Array.prototype.slice.call(newCount.cloneNode(true).childNodes));
        });
        var countEl = this.querySelector('[data-np-cart-count]');
        var n = newCount.textContent.replace(/\D/g, '');
        if (countEl && n) countEl.textContent = '(' + n + ' item' + (n === '1' ? '' : 's') + ')';
      }

      showError(message) { console.warn('[np-birthday-cart-drawer]', message || 'Error'); }

      updateItem(itemIndex, quantity) {
        this.__npFallbackUpdate = true;
        var self = this;
        var item = this.querySelector('#CartItem-' + itemIndex);
        if (!item) return Promise.resolve();
        var current = parseInt(item.dataset.quantity || '0', 10);
        if (current === quantity) return Promise.resolve();

        this.setLoadingStatus(true);
        if (item.setLoading) item.setLoading(true);
        if (item.setDisabled) item.setDisabled(true);
        if (quantity === 0 && item.removeItem) {
          item.removeItem();
          this.setPreEmpty(this.querySelectorAll(ITEM_TAG).length === 1);
        }

        var sectionId = this.dataset.sectionId;
        var body = { quantity: quantity, sections: sectionId, sections_url: window.location.pathname };
        if (item.dataset.key) body.id = item.dataset.key;
        else body.line = (parseInt(item.dataset.index, 10) || 0) + 1;

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'include',
          body: JSON.stringify(body)
        }).then(function (res) {
          return res.text().then(function (txt) {
            var data = {};
            try { data = JSON.parse(txt); } catch (e) {}
            return { ok: res.ok, status: res.status, data: data };
          });
        }).then(function (r) {
          if (!r.ok || r.data.errors) throw new Error(r.data.description || r.data.message || 'cart change failed');
          var html = r.data.sections && r.data.sections[sectionId];
          if (html != null) {
            self.applyFromSectionDoc(new DOMParser().parseFromString(html, 'text/html'));
          } else if (window.NPCartSync && window.NPCartSync.refresh) {
            return window.NPCartSync.refresh({ open: true });
          }
        }).catch(function (e) {
          self.showError(e && e.message);
          if (window.NPCartSync && window.NPCartSync.refresh) return window.NPCartSync.refresh({ open: true });
        }).then(function () {
          self.setLoadingStatus(false);
        });
      }

      removeItem() {}

      applyFromSectionDoc(doc) {
        var body = this.getTemplateContent(doc);
        if (body) this.mount(body);
        var fresh = doc.querySelector(DRAWER_TAG) || doc.querySelector('#' + this.id);
        if (fresh) {
          this.toggleAttribute('is-empty', fresh.hasAttribute('is-empty'));
          this.toggleAttribute('empty-cart', fresh.hasAttribute('empty-cart'));
        } else {
          this.updateEmptyStatus();
        }
        this.updateHeaderCountFromDoc(doc);
      }
    });
  }

  function boot() {
    if (!window.customElements) return;
    defineCartItem();
    defineCartDrawer();
  }

  ready(boot);
  document.addEventListener('shopify:section:load', function (e) {
    var drawer = e.target && e.target.querySelector ? e.target.querySelector(DRAWER_TAG) : null;
    if (drawer && typeof drawer.mount === 'function') { drawer.__wired = false; drawer.connectedCallback(); }
  });
})();
